/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalGrillW36Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalGrillW36').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRILL_LYNX_PROFESSIONAL_L36',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-grill-w-36.js.map